import { PricePage } from '../components/pages'

export default PricePage
